angular.module('homebot.services')

.factory('NavDropdownService', ['$rootScope', function($rootScope){

  return {
    set: function(dropdown){
      if(dropdown)
        this.currentDropdown = dropdown;
      else
        this.currentDropdown = null;

      $rootScope.$broadcast('NavDropdownChange', {
        currentDropdown: this.currentDropdown,
      });
    },
  }
}]);
